import * as React from "react";
import { Nav, Navbar } from "react-bootstrap";

import type { AccountWithoutPassword } from "../../../../../server/models/account";
import { navbarColor } from "../../../lib/navbar-color";
import { LogoWithDropdown } from "../logo-with-dropdown";

export type TopPageNavigationBarProps = {
	account: AccountWithoutPassword;
	onLogout: () => void;
	onMenuPage: () => void;
};

export const TopPageNavigationBar = ({ account, onLogout, onMenuPage }: TopPageNavigationBarProps) => {
	return (
		<Navbar bg={navbarColor} className="px-3" expand="lg" fixed="top" variant="dark">
			<LogoWithDropdown title="Test it" account={account} />

			<Navbar.Toggle aria-controls="basic-navbar-nav" />

			<Navbar.Collapse id="basic-navbar-nav" style={{ fontSize: 10.8 }}>
				<Nav className="me-auto" />

				<Nav>
					<Nav.Link onClick={onMenuPage}>
						<i className="bi bi-gear" style={{ fontSize: 12.8 }} />
					</Nav.Link>

					<Navbar.Text style={{ marginLeft: "20px", marginRight: "10px" }}>ログイン名: {account.name}さん</Navbar.Text>

					<Nav.Link onClick={onLogout}>Logout</Nav.Link>
				</Nav>
			</Navbar.Collapse>
		</Navbar>
	);
};
